// extracted by mini-css-extract-plugin
export var alignBaseline = "_2-9";
export var alignCenter = "_2-5";
export var alignFlexEnd = "_2-7";
export var alignFlexStart = "_2-6";
export var alignSelfBaseline = "_2-e";
export var alignSelfCenter = "_2-a";
export var alignSelfFlexEnd = "_2-c";
export var alignSelfFlexStart = "_2-b";
export var alignSelfStretch = "_2-d";
export var alignStretch = "_2-8";
export var column = "_2-2";
export var columnReverse = "_2-4";
export var flex = "_2-0";
export var justifyCenter = "_2-f";
export var justifyFlexEnd = "_2-h";
export var justifyFlexStart = "_2-g";
export var justifySpaceAround = "_2-j";
export var justifySpaceBetween = "_2-i";
export var justifySpaceEvenly = "_2-k";
export var row = "_2-1";
export var rowReverse = "_2-3";
export var wrapNowrap = "_2-m";
export var wrapWrap = "_2-l";
export var wrapWrapReverse = "_2-n";